import React from 'react';
import { createUseStyles } from 'react-jss';
import classNames from 'classnames';
import { DemoDefault, Demo2, Devices, Demo3, Demo4, Demo5 } from '../components/Images';

const useStyles = createUseStyles({
	demos: {
		paddingTop: '10rem',
		paddingBottom: '10rem',
	},
	tile: {
		height: 600,
	},
	chooseYourSide: {
		background: 'linear-gradient(to top right, #1f2d3d, #75a3cf);',
	},
});

const SectionDemos = () => {
	const classes = useStyles({});
	const demosData = [
		{
			id: 1,
			title: 'Modern',
			desc: 'Trendy with rounded corners and shading',
			img: DemoDefault,
			link: 'https://facit-modern.omtanke.studio',
		},
		{
			id: 2,
			title: 'Classic',
			desc: "A standard look for those who can't give up on the classic",
			img: Demo2,
			link: 'https://facit-classic.omtanke.studio/',
		},
		{
			id: 3,
			title: 'Minimal',
			desc: 'If you want to use the screen wider',
			img: Demo3,
			link: 'https://facit-minimal.omtanke.studio/',
		},
		{
			id: 4,
			title: 'Zen',
			desc: 'You can hide the menu to fully focus',
			img: Demo4,
			link: 'https://facit-zen.omtanke.studio/',
		},
		{
			id: 5,
			title: 'Colorful',
			desc: 'You are free to color',
			img: Demo5,
			link: 'https://facit-colors.omtanke.studio/',
		},
	];
	return (
		<div id='demos' className={classNames('row scroll-margin', classes.demos)}>
			<div className='col-12 display-4 fw-bold mb-3'>Demos</div>
			<div className='col-md-8 h4 mb-5'>
				{/* eslint-disable-next-line react/no-unescaped-entities */}
				More than a template can be called a core. That's why we named it <b>facit</b>, it
				does everything you want it to do. All by changing a few variables. It has more than
				700 variables.
			</div>

			<div className='col-12 mt-5'>
				<div className='row g-4 align-items-center'>
					<div className='col-lg-4'>
						<div
							className={classNames(
								'card border-0 text-white',
								classes.tile,
								classes.chooseYourSide,
							)}>
							<div
								className={classNames('card-body px-4 py-5 choose-your-side-bg')}
								style={{ backgroundImage: `url(${Devices}` }}>
								<p className='h4 mt-3'>Small actions big differences</p>
								<p className='lead'>
									No need to search to find, <b>just set</b>.
								</p>
							</div>
						</div>
					</div>
					{demosData.map((i) => (
						<div key={i.id} className='col-lg-4 preview-container'>
							<div
								className={classNames(
									'card overflow-hidden border-0',
									classes.tile,
								)}>
								<div className='card-header bg-transparent px-4 py-5'>
									<div className='row mb-3 align-items-center'>
										<div className='col'>
											<p className='h4'>{i.title}</p>
										</div>
										<div className='col-auto'>
											<a
												href={i.link}
												target='_blank'
												className='btn btn-outline-dark btn-lg px-5 py-3 rounded-1 fw-bold'
												rel='noreferrer'>
												Preview
											</a>
										</div>
									</div>
									<div className='row'>
										<div className='col'>
											<p className='lead text-muted'>{i.desc}</p>
										</div>
									</div>
								</div>
								<div className='card-body d-flex align-items-center'>
									<img
										src={i.img}
										alt={`${i.title} Version`}
										className='preview-image'
									/>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default SectionDemos;
